<template>
	<div class="container-fluid" id="profile_section">
		<div>
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="fas fa-users pr-1"></i>
						<span v-text="this.$route.meta.title"></span> (<small v-text="totalRows"></small>)
					</h2>
				</div>
			</div>

			<div class="row" id="members_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search Members"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-5 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-7 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						id="teams_table"
						bordered
						responsive="md"
						:items="members"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
						empty-text="There are no team members to show..."
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template #thead-top="">
							<b-tr v-if="thead_top.length > 0">
								<b-th
									v-for="(v, k) in thead_top"
									:key="k"
									:colspan="v.colspan"
									:variant="v.variant"
									:class="v.class"
								>
									<span v-text="v.text"></span>
								</b-th>
							</b-tr>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown size="sm" class="" toggle-class="text-decoration-none" no-caret>
								<template #button-content>
									<i class="fas fa-angle-down gold"></i>

									<!-- <span v-if="data.item.alerts.total > 0" class="mr-1">
										<i class="fas fa-bell text-danger"></i>
									</span>
									<span v-else>
										<i class="fas fa-angle-down gold"></i>
									</span> -->
								</template>

								<b-dropdown-item>
									<router-link :to="'/profile_report/' + data.item.id" class="gold">
										View <span v-text="data.item.first_name"></span>'s Report
									</router-link>
								</b-dropdown-item>
							</b-dropdown>
						</template>

						<template v-slot:cell(full_name)="data">
							<span v-text="data.item.full_name"></span>
						</template>

						<template v-slot:cell(user_score)="data">
							<router-link
								v-if="data.item.user_score > 0"
								:to="'/dashboard/' + data.item.id"
								class="d-flex"
							>
								<b-progress
									:value="data.item.user_score"
									max="100"
									show-value
									:variant="progressColour(data.item.user_score)"
									style="height: 20px; width: 150px"
									class="float-right"
								></b-progress>
							</router-link>

							<small
								v-for="(val, index) in data.item.score_data.type"
								:key="'score_' + index"
							>
								- <small v-text="index"></small>: <span v-text="val"></span>
							</small>
						</template>

						<template v-slot:cell(level)="data">
							<span v-text="arrayElmGet(options.levels, data.item.level)"></span>
						</template>

						<template v-slot:cell(last_session)="data">
							<span v-text="data.item.last_session.date" class="mr-1"></span>
							<span v-text="data.item.last_session.time"></span>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'Teams',
	components: {},
	props: {},
	data() {
		return {
			modal: {
				title: '',
				submitDisabled: true,
				member: {},
				errors: {
					process: '',
				},
			},
			modal_dashboard: {
				title: '',
				member: {},
			},
			modal_member_default: {
				id: 0,
				first_name: '',
				last_name: '',
				user_name: '',
				email: '',
				phone: '',
				status: 1,
				level: 20,
			},
			options: {
				levels: [
					{ value: 0, text: 'Pending' },
					{ value: 20, text: 'Member' },
					{ value: 30, text: 'Team Coach' },
					{ value: 50, text: 'Editor' },
					{ value: 90, text: 'Admin' },
					{ value: 99, text: 'WebMaster' },
				],
				statuses: [
					{ value: 0, text: 'Closed' },
					{ value: 1, text: 'Active' },
				],
			},
			errors: {},
			members: null,
			fields: [],
			thead_top: [],
			isBusy: true,
			sortBy: null,
			sortDesc: true,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
			muse: {
				file: null,
				processing: 0,
				message: '',
			},
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		teamMembersGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);

			if (this.$route.params.team_id) {
				params.append('team_id', this.$route.params.team_id);
			}

			var _URL = _this.$store.state.api_url + 'teamMembersGet';

			axios({
				url: _URL,
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.thead_top = response.data.fields.thead_top;
						_this.fields = response.data.fields.data;
						_this.members = response.data.members;
						_this.sortBy = response.data.fields.sort.sortBy;
						_this.sortDesc = response.data.fields.sort.sortDesc;
					} else {
						_this.members = null;
					}
					_this.totalRows = _this.members.length;
				})
				.catch(function () {
					console.log('Error: boardDataGet.');
				});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	created() {},
	mounted() {
		this.teamMembersGet();
	},
	watch: {},
};
</script>

<style scoped>
th.score_width {
	min-width: 180px !important;
}
th.last_session {
	min-width: 160px !important;
}
</style>
